<template>
  <div class="the-navbar__user-meta flex items-center" v-if="AppActiveUser.displayName">
    <div class="text-right leading-tight hidden sm:block">
      <p class="font-semibold">{{ AppActiveUser.displayName }}</p>
      <small>
        {{ $t('messages.welcome') }}
      </small>
    </div>

    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
      <div class="con-img ml-3">
        <vs-avatar :src="avatarSrc" size="40px" class="shadow-md cursor-pointer block" alt="user-img" />
      </div>

      <vs-dropdown-menu class="vx-navbar-dropdown">
        <ul style="min-width: 9rem">
          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            v-if="this.$store.state.windowWidth <= 760 && wallet"
          >
            {{ $t('wallets.credit') }}: {{ wallet.amount | toman }}
          </li>

          <vs-divider v-if="this.$store.state.windowWidth < 760 && wallet" class="m-1" />

          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="$router.push({ name: 'profile-settings' }).catch(() => {})"
          >
            <feather-icon icon="UserIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">{{ $t('users.profile_settings') }}</span>
          </li>

          <vs-divider class="m-1" />

          <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white" @click="logout">
            <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">{{ $t('users.logout') }}</span>
          </li>
        </ul>
      </vs-dropdown-menu>
    </vs-dropdown>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data() {
    return {
      avatarSrc: null
    }
  },
  computed: {
    ...mapState(['AppActiveUser']),
    wallet() {
      return this.$store.state.AppActiveUser.wallet
    }
  },
  watch: {
    AppActiveUser(value) {
      this.avatarSrc = value.avatarSrc
    }
  },
  methods: {
    logout() {
      this.$store.dispatch('auth/logout')
    }
  },
  created() {
    if (this.AppActiveUser.avatar) {
      this.$store.dispatch('file/downloadFile', this.AppActiveUser.avatar).then(response => {
        this.$store.commit('UPDATE_USER_INFO', { avatarSrc: response })
        this.$set(this.$store.state.AppActiveUser, 'avatarSrc', response)
        this.avatarSrc = response
      })
    }
  }
}
</script>
